import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useModal } from "../../store/modal/hooks";
import { RootState } from "../../store/store";
import { FloppyDiskIcon, SuccessIcon } from "../common/Icons";
import { StandardModal } from "./StandardModal";
import { openPartnerProjectDetails } from "../../utils/partnerLink";

const Content = styled.div`
  height: ${(props) => props.theme.designHeight(150)}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SaveConfigurationSuccess = () => {
    const { t } = useTranslation() as any;
    const { closeModal } = useModal();
    const projectId = useSelector(
        (state: RootState) => state.referral.projectId
    );
    const savedConfigurationRecordId = useSelector(
        (state: RootState) => state.modal.savedConfigurationRecordId
    );

    const handleProjectDetailsClick = () => {
        openPartnerProjectDetails({
            recordId: savedConfigurationRecordId,
            projectId,
            newDesign: true,
        });
    };

    return (
        <StandardModal
            title={t("account.configurationModal.modalTitle")}
            buttonText={
                projectId
                    ? t("account.configurationModal.projectDetails")
                    : t("account.configurationModal.close")
            }
            handleSubmit={projectId ? handleProjectDetailsClick : closeModal}
            subtitle={t("account.configurationModal.success")}
            titleIcon={FloppyDiskIcon}
            classnames={"success standard-modal"}
        >
            <Content>
                <SuccessIcon />
            </Content>
        </StandardModal>
    );
};